import { useEffect } from "react";

export const Section = ({ id, className = "", children }) => (
  <section id={id} className={`py-20 lg:py-28 ${className}`}>
    <div className="max-w-7xl mx-auto px-6 lg:px-8">{children}</div>
  </section>
);

export const Overline = ({ children }) => (
  <span className="text-sm uppercase tracking-[0.2em] font-bold text-sky-500">{children}</span>
);

export const usePageTitle = (title) => {
  useEffect(() => {
    document.title = `${title} | Equinoxe Propreté — Cahors & Lot`;
  }, [title]);
};
